/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { ProdutosService } from '../services/api/estoque/produtos/ProdutosService';

type TAutoCompleteOption = {
  idprod: string;
  label: string;
  descricao: string;
  marca: string;
  vencimento: boolean;
  referencia: string;
  precoSaida: number;
  pvenda: number;
  idproduto: string;
  un: string;
  cfop: number;
  // String mesmo ('00', '10', ...) — o cadastro de produto guarda o Cst como
  // texto (ver DetalheDeProduto.tsx), nunca foi um number de verdade.
  cst: string;
  origem: number;
  cstipi: string;
  cstpis: string;
  cstcofins: string;
  picms: number;
  pipi: number;
  ppis: number;
  pcofins: number;
  ean: string;
  ncm: string;
  // Quantidade de GLP derivado de petróleo (só produto ANP cProdANP=
  // 210203001) — quando > 0, a tela de item de NFe usa 10 casas decimais no
  // Preço Tributado em vez das 4 padrão (ver DialogNfe.tsx).
  qtdglp: number;
  // "TAX" do cadastro de produto (ver DetalheDeProduto.tsx) — quando false,
  // o item de NFe já entra com Ind. Total desmarcado por padrão.
  tax: boolean;
};
interface IAutoCompleteProdutoProps {
  isExternalLoading?: boolean;
  filtro?: string;
  un?: (valor: string | undefined) => void;
  referencia?: (valor: string | undefined) => void;
  descricao?: (valor: string | undefined) => void;
  marca?: (valor: string | undefined) => void;
  vencimento?: (valor: boolean | undefined) => void;
  precoSaida?: (valor: number | undefined) => void;
  pVenda?: (valor: number | undefined) => void;
  idproduto?: (valor: string | undefined) => void;
  Cfop?: (valor: number | undefined) => void;
  origem?: (valor: number | undefined) => void;
  cst?: (valor: string | undefined) => void;
  cstipi?: (valor: string | undefined) => void;
  cstpis?: (valor: string | undefined) => void;
  cstcofins?: (valor: string | undefined) => void;
  picms?: (valor: number | undefined) => void;
  pipi?: (valor: number | undefined) => void;
  ppis?: (valor: number | undefined) => void;
  pcofins?: (valor: number | undefined) => void;
  ean?: (valor: string | undefined) => void;
  ncm?: (valor: string | undefined) => void;
  qtdglp?: (valor: number | undefined) => void;
  tax?: (valor: boolean | undefined) => void;
}
export const AutoCompleteProdutoIdProduto: React.FC<IAutoCompleteProdutoProps> = ({ isExternalLoading = false, referencia, descricao, vencimento, precoSaida, pVenda, marca,
  un, idproduto, Cfop, cst, cstipi, cstpis,  cstcofins, picms, pipi, ppis, pcofins, origem,ean,ncm,qtdglp,tax,
  filtro = 'descricao',
}) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idprodutos');
  const { debounce } = useDebounce();
  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');
  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);
useEffect(() => {
}, [opcoes]);
  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      ProdutosService.getAlllist(busca, selectedId, filtro)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            return;
          }
          if (filtro === 'descricao') {
            setOpcoes(
              result.data.map((produto: any) => ({
                idprod: produto.idproduto,
                label: produto.descricao,
                referencia: produto.referencia,
                marca: produto.marca,
                descricao: produto.descricao,
                vencimento: produto.vencimento ?? false,
                precoSaida: produto.precosaida,
                pvenda: produto.pvenda,
                idproduto: produto.idproduto,
                un: produto.un,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                picms: Number(produto.picms) || 0,
                // Number(...): esses 3 são coluna numeric/decimal no Postgres — o
                // driver pg devolve como STRING (ex.: "5.50"), e o campo de
                // percentual (VFieldMoneyNumber2) assume que toda string está em
                // formato BR (vírgula decimal) quando recebe algo que não é
                // `typeof number`, então "5.50" virava 550 em vez de 5,50.
                pipi: Number(produto.pipi) || 0,
                ppis: Number(produto.ppis) || 0,
                pcofins: Number(produto.pcofins) || 0,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
                qtdglp: Number(produto.qtdglp) || 0,
                tax: produto.tax !== false,
              }))
            );
          } else if (filtro === 'codbarraentrada') {
            setOpcoes(
              result.data.map((produto: any) => ({
                idprod: produto.idproduto,
                label: produto.codbarraentrada,
                referencia: produto.referencia,
                descricao: produto.descricao,
                marca: produto.marca,
                vencimento: produto.vencimento ?? false,
                precoSaida: produto.precosaida ?? produto.preco ?? 0,
                pvenda: produto.pvenda ?? produto.preco ?? 0,
                idproduto: produto.idproduto,
                un: produto.un,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                picms: Number(produto.picms) || 0,
                // Number(...): esses 3 são coluna numeric/decimal no Postgres — o
                // driver pg devolve como STRING (ex.: "5.50"), e o campo de
                // percentual (VFieldMoneyNumber2) assume que toda string está em
                // formato BR (vírgula decimal) quando recebe algo que não é
                // `typeof number`, então "5.50" virava 550 em vez de 5,50.
                pipi: Number(produto.pipi) || 0,
                ppis: Number(produto.ppis) || 0,
                pcofins: Number(produto.pcofins) || 0,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
                qtdglp: Number(produto.qtdglp) || 0,
                tax: produto.tax !== false,
              }))
            );
          } else if (filtro === 'codbarrasaida') {
            setOpcoes(
              result.data.map((produto: any) => ({
                idprod: produto.idproduto,
                label: produto.codbarrasaida,
                referencia: produto.referencia,
                descricao: produto.descricao,
                marca: produto.marca,
                vencimento: produto.vencimento ?? false,
                precoSaida: produto.precosaida ?? produto.preco ?? 0,
                pvenda: produto.pvenda ?? produto.preco ?? 0,
                idproduto: produto.idproduto,
                un: produto.un,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                picms: Number(produto.picms) || 0,
                // Number(...): esses 3 são coluna numeric/decimal no Postgres — o
                // driver pg devolve como STRING (ex.: "5.50"), e o campo de
                // percentual (VFieldMoneyNumber2) assume que toda string está em
                // formato BR (vírgula decimal) quando recebe algo que não é
                // `typeof number`, então "5.50" virava 550 em vez de 5,50.
                pipi: Number(produto.pipi) || 0,
                ppis: Number(produto.ppis) || 0,
                pcofins: Number(produto.pcofins) || 0,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
                qtdglp: Number(produto.qtdglp) || 0,
                tax: produto.tax !== false,
              }))
            );
          } else if (filtro === 'referencia') {
            setOpcoes(
              result.data.map((produto) => ({
                idprod: produto.idproduto,
                label: produto.descricao + ' - ' + produto.referencia,
                referencia: produto.referencia,
                descricao: produto.descricao,
                marca: produto.marca,
                vencimento: produto.vencimento,
                precoSaida: produto.precosaida,
                un: produto.un,
                pvenda: produto.pvenda,
                idproduto: produto.idproduto,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                picms: Number(produto.picms) || 0,
                // Number(...): esses 3 são coluna numeric/decimal no Postgres — o
                // driver pg devolve como STRING (ex.: "5.50"), e o campo de
                // percentual (VFieldMoneyNumber2) assume que toda string está em
                // formato BR (vírgula decimal) quando recebe algo que não é
                // `typeof number`, então "5.50" virava 550 em vez de 5,50.
                pipi: Number(produto.pipi) || 0,
                ppis: Number(produto.ppis) || 0,
                pcofins: Number(produto.pcofins) || 0,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
                qtdglp: Number(produto.qtdglp) || 0,
                tax: produto.tax !== false,
              })),
            );
          }
        });
    });
  }, [busca, selectedId, filtro, debounce]);
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;
    const selectedOption = opcoes.find((opcao) => opcao.idprod === selectedId);
    return selectedOption ?? null;
  }, [selectedId, opcoes]);
  // pVenda/precoSaida NÃO são disparados aqui a partir de autoCompleteSelectedOption:
  // esse memo também resolve quando um item já existente é carregado pra edição
  // (selectedId chega pronto via setData, sem passar pelo onChange abaixo) — nesse caso
  // preco/precotrib já vêm com o valor salvo no item, e sobrescrever aqui com o pvenda
  // atual do produto reaplicaria o preço de venda de hoje por cima do valor tributado
  // salvo. Selecionar um produto de fato (usuário escolhendo no Autocomplete) já chama
  // pVenda/precoSaida direto no onChange logo abaixo.
  return (
    <Autocomplete
      openText="Abrir"
      closeText="Fechar"
      noOptionsText="Sem opções"
      loadingText="Carregando..."
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, value) => option.idprod === value.idprod}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => {
        setSelectedId(newValue?.idprod);
        idproduto?.(newValue?.idprod);
        referencia?.(newValue?.referencia);
        marca?.(newValue?.marca); 
        descricao?.(newValue?.descricao);
        un?.(newValue?.un);
        vencimento?.(newValue?.vencimento);
        precoSaida?.(newValue?.precoSaida);
        pVenda?.(newValue?.pvenda);
        Cfop?.(newValue?.cfop);
        cst?.(newValue?.cst);
        cstipi?.(newValue?.cstipi);
        cstpis?.(newValue?.cstpis);
        cstcofins?.(newValue?.cstcofins);
        picms?.(newValue?.picms);
        pipi?.(newValue?.pipi);
        ppis?.(newValue?.ppis);
        pcofins?.(newValue?.pcofins);
        ean?.(newValue?.ean);
        ncm?.(newValue?.ncm);
        origem?.(newValue?.origem);
        qtdglp?.(newValue?.qtdglp);
        tax?.(newValue?.tax);
        setBusca('');
        clearError();
      }}
      popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label="Pesquisar ítem"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};
